import { useNavigate, useParams } from 'react-router-dom';
import { BookingStepper } from 'booking/components';
import { CompleteStoreFragment, Maybe, useGetStoreQuery } from 'drycut-graphql';
import { useDocumentTitle } from 'usehooks-ts';
import { Loader } from 'ui-components';
import StorePubSubWrapper from '../StorePubSubWrapper';

export function NewBooking(): React.ReactNode {
  useDocumentTitle('DRYCUT - Book');

  const { slug } = useParams() as { slug: string };
  const { data, loading } = useGetStoreQuery({ variables: { slug } });
  const navigate = useNavigate();

  const store: Maybe<CompleteStoreFragment> = data?.store || null;

  if (loading) {
    return <Loader />;
  }

  if (!store || !store.active) {
    navigate('/not-found');
    return null;
  }

  return (
    <StorePubSubWrapper slug={slug}>
      <BookingStepper store={store} />
    </StorePubSubWrapper>
  );
}
